// Module
var code = "<div layout=\"column\" class=\"full-height\"> <bringoz-service-areas-view flex permission=\"'drivers.update'\" selected-area-ids=\"$ctrl.preferences.priorityServiceAreas\" branch-ids=\"$ctrl.agent.branchIds\" on-change=\"$ctrl.onServiceAreaChange(updatedAreas)\"> </bringoz-service-areas-view> </div> ";
// Exports
export default code;